<template>
  <v-main>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <h1 class="mt-n2">{{$t("Corporations")}}</h1>
        </v-flex>
        <v-flex xs12>
          <v-row>
            <v-btn class="ml-3" to="corporations/create" color="primary">
              <v-icon left>add</v-icon>
              {{$t("New")}}
            </v-btn>
            <v-flex grow></v-flex>
            <v-checkbox class="ml-3 mt-1 mr-3" :label="ct.Show_inactive" v-model="showInactive" :color="'primary'"></v-checkbox>
          </v-row>
        </v-flex>
        <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
        <v-flex v-else xs12>
          <v-data-table
            :headers="headers"
            :items="corporations.filter(item => showInactive || item.DeletedDate === null)"
            class="elevation-1 mt-2"
            item-key="Id"
            show-expand
          >
            <template v-slot:[`item.CreatedDate`]="{ item }">
              {{ formatDate(item.CreatedDate) }}
            </template>
            <template v-slot:[`item.DeletedDate`]="{ item }">
              {{ formatDate(item.DeletedDate) }}
            </template>

            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <v-btn color="primary" :to="{name: 'editCorporation', params: {id: item.Id}}">
                  <v-icon left>edit</v-icon>
                  {{$t("Edit")}}
                </v-btn>
              </td>
            </template>

          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import { app } from '@/main'
import ct from '@/core/mixins/common-translations'
import filters from '@/core/mixins/common-filters'
import formatDate from '@/core/mixins/formatDate'
import * as Admin from '@/core/admin'

export default {
  mixins: [ct, filters, formatDate],
  data () {
    return {
      loading: true,
      showInactive: false,
      corporations: []
    }
  },
  // filters: {
  //   asDate: function (date) {
  //     return DateUtil.getSmartDate(date)
  //   }
  // },
  computed: {
    headers () {
      return [
        {
          text: this.$t('No.'),
          value: 'Id'
        },
        {
          text: this.$t('Name'),
          value: 'Name'
        },
        {
          text: this.$t('Full name'),
          value: 'FullName'
        },
        {
          text: this.$t('Created'),
          value: 'CreatedDate'
        },
        {
          text: this.$t('Inactive'),
          value: 'DeletedDate'
        }
      ]
    }
  },
  async mounted () {
    // We use next tick to ensure that app is initialized
    this.$nextTick(() => {
      app.$on('force-update', () => {
        // We need this to ensure that autoLogin re-renders component
        this.$forceUpdate()
      })
    })

    const res = await Admin.loadCorporations()
    if (!res.failed) this.corporations = res.data
    this.loading = false
  }
}
</script>
